module.exports = __webpack_public_path__ + "img/dark_droid.7aa71824.png";